<template>
  <!-- Fields dinamycs;  note: will be can abstract to component for N times and use en another component form -->
  <div>
    <h4 v-if="fieldsExtraConfig.length" class="my-4">
      Datos adicionales {{ title }}
    </h4>
    <CRow>
      <CCol sm="12" md="9" lg="9">
        <ExtraConfigNodo :campos="fieldsExtraConfig" v-model="value" />
      </CCol>
    </CRow>
  </div>
  <!-- End fields dinamycs -->
</template>

<script>
import ExtraConfigNodo from "./ExtraConfigNodo";
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    parametro: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ExtraConfigNodo
  },
  computed: {
    fieldsExtraConfigVal() {
      const recursiveConfig = (v, c) => {
        if (c.tipo === "field_set") {
          return c.campos.reduce(recursiveConfig, v);
        } else {
          v.push({ ...c, value: this.value[c.nombre] });
        }
        return v;
      };
      const fields = this.fieldsExtraConfig.reduce(recursiveConfig, []);
      return fields;
    }
  },
  watch: {
    fieldsExtraConfig(newValue) {
      this.$emit("config", newValue);
    },
    value: {
      handler(newValue) {
        const fieldsExtraConfigVal = {
          flag: this.fieldsExtraConfigVal.every(
            e => !e.required || (e.required && this.validValue(e))
          ),
          valores: this.fieldsExtraConfigVal
            .filter(ff => ff.required && !this.validValue(ff))
            .map(m => m.etiqueta)
        };
        console.log("onValid", fieldsExtraConfigVal);
        console.log("input", newValue);
        this.$emit("onValid", fieldsExtraConfigVal);
        this.$emit("input", newValue);
      },
      deep: true
    },
    parametro() {
      this.fetchData();
    }
  },
  data() {
    return {
      fieldsExtraConfig: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    validValue(e) {
      if (e.tipo.includes("select")) {
        return e.value || (e.value !== undefined && e.value !== null);
      } else {
        return e.value;
      }
    },
    setKey(key, targetObject) {
      var keys = key.split("."),
        obj = targetObject || window,
        keyPart;
      while ((keyPart = keys.shift()) && keys.length) {
        obj = obj[keyPart];
      }
      return obj[keyPart];
    },
    fetchData() {
      this.$store
        .dispatch("customHTTP", {
          schema: "configuracion",
          filter: {
            where: [
              {
                field: "payload->parametro",
                value: this.parametro,
                operator: "="
              }
            ]
          }
        })
        .then(response => {
          if (response.data.length === 0) {
            return;
          }
          this.fieldsExtraConfig = response.data[0].payload.valor;
          // the logic transform to funtion for clean code
          const recursiveConfig = fieldIndex => {
            if (fieldIndex.tipo === "field_set") {
              //this.$emit('input',{...this.value,[fieldIndex.nombre]:this.value[fieldIndex.nombre]||{}})
              return fieldIndex.campos.forEach(recursiveConfig);
            }
            if (fieldIndex.tipo === "select_remoto") {
              const config = fieldIndex.config;
              fieldIndex.config.data = [];
              const tipo = { cat: "customHTTP", doc: "customDocumentoHTTP" }[
                config.type
              ];
              this.$store
                .dispatch(tipo, {
                  schema: config.schema,
                  filter: config.filtro
                })
                .then(res => {
                  fieldIndex.config = res.data.map(item => {
                    return {
                      value: this.setKey(`${config.valor}`, item),
                      label: this.setKey(`${config.etiqueta}`, item)
                    };
                  });
                });
            }
            fieldIndex.tipo =
              fieldIndex.tipo === "string" ? "text" : fieldIndex.tipo;
            fieldIndex.tipo =
              fieldIndex.tipo === "numeric" ? "number" : fieldIndex.tipo;
            fieldIndex.tipo =
              fieldIndex.tipo === "select_local" ? "select" : fieldIndex.tipo;
            fieldIndex.tipo =
              fieldIndex.tipo === "select_remoto" ? "select" : fieldIndex.tipo;

            if (fieldIndex.tipo === "select") {
              fieldIndex.config = fieldIndex.config.data.map(indexSelect => {
                return {
                  value: indexSelect.valor,
                  label: indexSelect.etiqueta
                };
              });
            }
            this.$emit("input", {
              ...this.value,
              [fieldIndex.nombre]: this.value[fieldIndex.nombre] || ""
            });
          };
          this.fieldsExtraConfig.forEach(recursiveConfig);
          this.$emit("config", this.fieldsExtraConfig);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
